import { createFileRoute } from '@tanstack/react-router';

import { getProjectOptions } from '@/module/Author/Project';

export const Route = createFileRoute('/_auth/author/_author/project/_project/$projectId/_layout')({
  loader: async ({ params: { projectId }, context: { queryClient } }) => {
    const project = await queryClient.ensureQueryData(getProjectOptions(projectId));

    return {
      project,
      crumb: project.title,
    };
  },
});
